"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

/**
 * Passthrough component from Material UI Collapse:
 * https://material-ui.com/api/collapse/
 */
var Collapse = function Collapse(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.Collapse, props);
};

var _default = Collapse;
exports["default"] = _default;